import { render } from "./TableComponent.vue?vue&type=template&id=35c039bc"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=35c039bc&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__